export default "__VITE_ASSET__aa4c6693__"